import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { onReplaceLinkClick } from 'ctm-util-functions';
import { Icon } from 'ctm-components';
import { getLabelFromCode } from '../../core/state_selectors';
import { CarBrandIcon } from '../car_brand_icon/car_brand_icon';
import styles from './car_details_with_preview.css';
import { CarPreview } from '../car_preview/car_preview';

/**
 * Render the Car Details component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */

const _CarDetailsWithPreview = ({ make, model, year, body, transmission, fuel, description, badge }) => (
    <div className={styles.root}>
        <p className={styles.make_model}>
            {' '}
            <CarBrandIcon />
            {' '}
            {make}
            {' '}
            {model}
            {' '}
        </p>
        <p className={styles.details}>
            {year}
            {' '}
            |
            {' '}
            {body}
            {' '}
            |
            {' '}
            {transmission}
            {' '}
            |
            {' '}
            {fuel}
        </p>
        <p>{description}</p>
        <span> Not the vehicle? </span>
        <a
            data-id="edit_car_details_link"
            href="#"
            className={styles.detailsLink}
            onClick={(event) => onReplaceLinkClick(event, '/car-insurance/journey/edit_car_details')}>
            <Icon className={styles.edit_icon} variant="ctm_pencil" />
            <span className={styles.text}>Edit Details</span>
        </a>
        <span> if this doesn't look right...</span>
        <CarPreview />
    </div>
);

_CarDetailsWithPreview.propTypes = {
    make: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    transmission: PropTypes.string.isRequired,
    fuel: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

/**
 * Map state to our component props
 * @param {Object} state - the application state
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state) => {
    return {
        make: getLabelFromCode(state, 'coverDetail.vehicle.make', 'vertical.quote.apiResponses.makes'),
        year: getLabelFromCode(state, 'coverDetail.vehicle.year', 'vertical.quote.apiResponses.years'),
        model: getLabelFromCode(state, 'coverDetail.vehicle.model', 'vertical.quote.apiResponses.models'),
        body: getLabelFromCode(state, 'coverDetail.vehicle.body', 'vertical.quote.apiResponses.bodies'),
        transmission: getLabelFromCode(state, 'coverDetail.vehicle.transmission', 'vertical.quote.apiResponses.transmissions'),
        fuel: getLabelFromCode(state, 'coverDetail.vehicle.fuel', 'vertical.quote.apiResponses.fuel'),
        description: state.getIn('vertical.quote.apiResponses.description'.split('.')) || ''
    };
};

const CarDetailsWithPreview = connect(mapStateToProps)(_CarDetailsWithPreview);

export { CarDetailsWithPreview, _CarDetailsWithPreview };
